<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../../assets/images/banner_list.jpg" />
            <div class="btext">
                <h3>股权/资金投资项目</h3>
                <p>最新金融快讯，全球投资信息，行业特色综合类新闻资讯</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>股权/资金投资</el-breadcrumb-item>
                <el-breadcrumb-item>股权/资金投资项目</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="2"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/ecInvestmentIntroduction' }">
                            <el-menu-item index="1"><span slot="title" >股权/资金投资介绍</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/efInvestmentProject' }">
                            <el-menu-item index="2"><span slot="title">股权/资金投资项目</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/successfulCase' }">
                            <el-menu-item index="3"><span slot="title">成功案例</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <ul class="list_news" >
                            <li v-for="item in EfInvestmentProjectsArray"><span><a v-on:click="toEfInvestmentProjectDetail(item)">{{item.publishTime|date_from_unix_YearMonthDay}}</a></span><a v-on:click="toEfInvestmentProjectDetail(item)">{{item.title}}</a></li>
                        </ul>
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqEfInvestmentProjectList} from "../../../../api/contentManagement-api";

    export  default {
        data(){
            return{
                total:0,
                pageNum:1,
                pageSize:10,
                EfInvestmentProjectsArray:[],
            }
        },
        methods:{
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getEfInvestmentProject();
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getEfInvestmentProject();
            },
            getEfInvestmentProject(){
                reqEfInvestmentProjectList({pageNum: this.pageNum, pageSize: this.pageSize}).then((res)=>{
                    if(res.data.code===1){
                        this.total=res.data.data.total;
                        this.EfInvestmentProjectsArray=res.data.data.list;
                    }else {
                        this.EfInvestmentProjectsArray=[{title:'抱歉，暂无数据'}];
                    }
                })
            },
            toEfInvestmentProjectDetail(item){
                this.$router.push({path:'/efInvestmentProjectDetail',query:{id:item.id,total:this.total}});
            },

        },
        mounted(){
            this.getEfInvestmentProject();
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/contentManagement/ecInvestment/efInvestmentProject/EfInvestmentProject.vue